import { NavLink } from 'react-router-dom';
import CustomerHead from '../../components/customer/CustomerHead';

import { FaPencilAlt } from "react-icons/fa";

import styled from 'styled-components';
import React, {useEffect, useState} from "react";

import * as Server from 'assets/js/Server';

export default function Complaint(){
  const [userList, setUserList] = useState([]);
  const [result, setResult] = useState({
    userId: '',
    lat: '',
    lon: '',
    sendType: 'qr',
  });

  const [list, setList] = useState([]);
  const [filterType, setFilterType] = useState('ALL'); // ALL | N | Y

  const getComplaintList = () => {
    Server.sendGet('customer/complaint', {}, getComplaintListCallback).then();
  }

  const getComplaintListCallback = res => {
    setList(res['resultList']);
  }

  useEffect(() => {
    getComplaintList();
  }, [])

  return (
    <ComplaintWrap>
      <CustomerHead title="Complaint" desc="Voice of Dissatisfaction" />
      <main className="content">
        <div className="card">
          <strong>Customer Requested List</strong>
          <div className="request-list">
            <div className="radio-box">
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'ALL'}
                  onChange={() => setFilterType('ALL')}
                />
                <label htmlFor="all">All</label>
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'N'}
                  onChange={() => setFilterType('N')}
                />
                <label htmlFor="before-process">Before</label>
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'Y'}
                  onChange={() => setFilterType('Y')}
                />
                <label htmlFor="completed-process">Completed</label>
              </div>
            </div>
            <div className="table-wrap">
              <table>
                <colgroup>
                  <col width="25%" />
                  <col width="50%" />
                  <col width="25%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Patrol Area</th>
                    <th>Request date</th>
                    <th>State</th>
                  </tr>
                </thead>
                <tbody>
                  {list?.filter(item => filterType === 'ALL' || item.replyYn === filterType)?.map((result, idx) => (
                    <>
                      <tr>
                        <td>
                          <NavLink
                            to="/customer/complaint/detail"
                            state={{ data: result }}
                          >{result.patrolArea}</NavLink>
                        </td>
                        <td>
                          <
                            NavLink to="/customer/complaint/detail"
                            state={{ data: result }}
                          >{result.regDt}</NavLink>
                        </td>
                        <td>
                          <
                            NavLink to="/customer/complaint/detail"
                            state={{ data: result }}
                          >{result.replyYn === 'Y' ? 'Completed' : 'Before'}</NavLink>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <NavLink to="/customer/complaint/write" className="float-btn">
          <FaPencilAlt />
        </NavLink>
      </main>
    </ComplaintWrap>
  )
}

const ComplaintWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px;
    //height:calc(100vh - 132px);
    overflow-y:auto;
    
    .card {
      background:#fff;
      border-radius:12px;
      padding:20px;
      box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);
      overflow-y:auto;
      height:100%;

      strong {
        display:block;
        font-size:18px;
        font-weight:700;
        color:#111827;
      }
      
      .request-list {
        margin-top:15px;
        
        .radio-box {
          display:flex;
          align-items:center;
          gap:0 10px;
          
          .radio-item {
            display:flex;
            align-items:center;
            gap:0 5px;
            
            label {
              font-weight:400;
              font-size:14px;
              color:#111;
            }
          }
        }
      }
      
      .table-wrap {
        margin-top:30px;
        position:relative;
        width:100%;
        
        table {
          width:100%;
          
          th {
            padding:10px 20px;
            font-weight:500;
            font-size:14px;
            color:#fff;
            background:#0072B9;
            vertical-align: middle;
          }
          
          th + th {
            border-left:1px solid #fff;
          }
          
          td {
            padding:10px 20px;
            font-weight:500;
            font-size:14px;
            color:#111;
            border-bottom:1px solid #d4d4d4;
            text-align:center;
          }
          
          td + td {
            border-left:1px solid #d4d4d4;
          }
        }
      }
    }
    
    .float-btn {
      z-index:999;
      position:fixed;
      bottom:80px;
      right:30px;
      width:45px;
      height:45px;
      background:#0072B9;
      border-radius:50%;
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:16px;
      font-weight:600;
      color:#fff;
    }
  }
`
